import { styleSheets } from './globals';

/**
 * A method that mimics onload by polling document.styleSheets
 * until it includes the new sheet.
 *
 * @param  {String}   resolvedHref Resolved href of CSS-file.
 * @param  {Function} cb           Load callback.
 * @return {void}
 */
export default function onStyleLoad(resolvedHref, cb) {

	let i = styleSheets.length;

	while (i--) {
		if (styleSheets[i].href === resolvedHref) {
			cb();
			return;
		}
	}

	setTimeout(() => {
		onStyleLoad(resolvedHref, cb);
	});
}
